<template>
    <b-container fluid>
        <page-title>
            <h2>
                <router-link :to="{ name: 'AgreementList' }" class="nav-link">Umowy</router-link>/Nowa umowa
            </h2>
        </page-title>

        <div class="col page-element">
            <alert-loading v-if="isLoading"></alert-loading>
            <div v-if="error" class="alert alert-danger" role="alert">
                <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}
            </div>
            <b-card v-show="!isLoading" no-body>
                <b-tabs ref="tabs" card>
                    <b-tab title="Dane podstawowe" active>
                        <AgreementFormGeneral :handle-submit="create" :errors="violations" :values="item" ></AgreementFormGeneral>
                    </b-tab>
                    <b-tab title="Faktury" disabled="disabled"></b-tab>
                    <b-tab title="Dokumenty"  disabled="disabled"></b-tab>
                    <b-tab title="Zaliczki, Potrącenia, Zwroty"  disabled="disabled"></b-tab>
                    <b-tab title="Rozliczenie umowy"  disabled="disabled"></b-tab>
                </b-tabs>
            </b-card>
        </div>
    </b-container>
</template>

<script>
  import AgreementFormGeneral from './FormGeneral.vue'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      AgreementFormGeneral
    },
    data: function () {
      return {
        item: {
          date: '',
          customer: null,
          currency: null,
          commission: 0
        }
      }
    },

    computed: {
      isLoading () {
        if (this.loadingCustomer || this.loading) {
          return true
        }
        return false
      },
      ...mapGetters({
        loadingCustomer: 'agreement/customer/loading',
        customersList: 'agreement/customer/items',
        error: 'agreement/create/error',
        loading: 'agreement/create/loading',
        created: 'agreement/create/created',
        violations: 'agreement/create/violations'
      })
    },
    methods: {
      create: function (item) {
        this.$store.dispatch('agreement/create/create', item)
      },
    },
    watch:{
      created(result){
        if (result) {
          this.$router.push({ name: 'AgreementUpdate', params: { id: result['id'], tab: 'invoice'} });
        }
      },
      customersList(result){
        if(result && this.$route.query.customer  && result.length > 0 ){
          const customer = result.find((customer) => customer.id == this.$route.query.customer )
          this.item.customer = customer['@id']
        }
      }
    },
    created () {
      this.$store.dispatch('agreement/customer/load')
      this.$store.dispatch('agreement/create/reset')
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?502f273c